import React from "react";

export default function Box(props) {
  const {
    backgroundColor = "papayawhip",
    borderColor = "lightsalmon",
    title = "",
  } = props;
  return (
    <div
      style={{
        maxWidth: "50rem",
        marginBottom: "1.5rem",
        padding: "1rem",
        borderWidth: "3px",
        borderStyle: "double",
        position: "relative",
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-0.75em",
          padding: "0.25em 0.5em",
          fontWeight: "bold",
          textTransform: "uppercase",
          backgroundColor: backgroundColor,
        }}
      >
        {title}
      </div>
      {props.children}
    </div>
  );
}
